{
  "alert.informative": "Informative",
  "alert.negative": "Negative",
  "alert.notice": "Notice",
  "alert.positive": "Positive",
  "chat.newMessage": "Νέο μήνυμα",
  "chat.scrollToBottom": "Κύλιση προς τα κάτω",
  "messagefeedback.thumbDown": "Κακή απάντηση",
  "messagefeedback.thumbUp": "Καλή απάντηση",
  "promptfield.aiDisclaimer": "Οι απαντήσεις δημιουργούνται με χρήση τεχνητής νοημοσύνης και ενδέχεται να είναι ανακριβείς. Ελέγξτε πριν από τη χρήση.",
  "promptfield.aiUserGuidlines": "Οδηγίες χρήσης AI",
  "promptfield.attachments": "Συνημμένα",
  "promptfield.insertButton": "Προσθήκη",
  "promptfield.label": "Προτροπή",
  "promptfield.placeholder": "Είστε έτοιμοι να ξεκινήσετε; Υποβάλετε μια ερώτηση, μοιραστείτε μια ιδέα ή προσθέστε μια εργασία.",
  "promptfield.placeholder.small": "Ask anything",
  "promptfield.stopButton": "Σταμάτα",
  "promptfield.submitButton": "Αποστολή",
  "promptfield.uploading": "Μεταφόρτωση",
  "responsestatus.loading": "Φόρτωση",
  "responsestatus.processing": "Processing...",
  "voicebutton.startListening": "Ξεκινήστε την εγγραφή",
  "voicebutton.stopListening": "Διακοπή εγγραφής",
  "attachmentlist.previousAttachments": "Show previous attachments",
  "attachmentlist.nextAttachments": "Show next attachments"
}
